import { SET_CONTACT_MODAL_STATE } from '../actions/types'

const defaultState = {
  contactModalVisible: false,
  contact: {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumberCell: '',
  },
  persistenceType: '',
  contactType: 'createContact',
  isTenant: true,
  buildingId: '',
  apartmentId: '',
  history: {},
}

const contactModalState = (state = defaultState, action) => {
  const { type, payload } = action
  switch (type) {
    case SET_CONTACT_MODAL_STATE:
      return {
        ...state,
        ...payload,
      }
    default:
      return state
  }
}
export default contactModalState
